	<app-site-header></app-site-header>
<main class="site-body">
		<theme-switcher></theme-switcher>
	@if (isDateValid && dateData) {
		<!-- <app-calendar-entry
			[year]="year"
			[month]="month"
			[day]="day"
			[dayData]="dateData"
			[isStandalone]="true"
			(emitButtonAction)="navigate($event)"
		></app-calendar-entry> -->
		<app-calendar-entry
			[year]="year"
			[month]="month"
			[day]="day"
			[dayData]="dateData"
			[prevLink]="prevLink"
			[nextLink]="nextLink"
			(emitButtonAction)="navigate($event)"
			#calendarEntry
		></app-calendar-entry>
	}
</main>
	<app-footer></app-footer>
